import { CustomTabbedForm } from './CustomTabbedForm'
import { languages } from '../config/constants'

/**
 * LangRelatedTabbedForm - A specialized form component that automatically creates tabs for each language
 * 
 * @param {Array} generalFields - Array of React elements to render in the general section (above tabs)
 * @param {Function} tabFields - Function that receives a language object { id, label } and returns an array of React elements for that language's tab
 * @param {Object} formProps - Additional props to pass to the Form component
 */
export const LangRelatedTabbedForm = ({ generalFields = [], tabFields, ...formProps }) => {
  if (!tabFields || typeof tabFields !== 'function') {
    throw new Error('LangRelatedTabbedForm requires tabFields as a function that receives a language object')
  }

  const tabs = languages.map(lang => ({
    label: lang.label,
    fields: tabFields(lang),
  }))

  return (
    <CustomTabbedForm
      generalFields={generalFields}
      tabs={tabs}
      {...formProps}
    />
  )
}

